<template>
    <div v-if="showAdditionalServicesBlock && showBlock()"
         :class="['additional-services-block block',{'show': show}]">

        <!--Блок разварачивания-->
        <div @click="blockToggle('additionalServices')"
             class="block-toggle-bar align-center justify-between">
            <div class="block-name align-center justify-center">
                <svg width="16px" height="18px" fill="var(--white-color)" fill-opacity="0.7">
                    <use xlink:href="../../../assets/images/sprite.svg#map-icon"></use>
                </svg>
                <span class="ml-8">{{ localizeList.tourProgram }}</span>
            </div>
            <svg width="8px" height="12px" fill="var(--white-color)" class="angle-icon">
                <use xlink:href="../../../assets/images/sprite.svg#angle"></use>
            </svg>
        </div>
        <div v-if="show"
             class="additional-services-info-wrap">
            <div v-for="(item, key) in getGroup"
                 v-show="showGroup(item)"
                 :key="key"
                 :style="{'order': getOrder(item.group[0])}"
                 class="additional-services-info">
                <h3 class="additional-services-info-headline">{{ item.group[0].title|capitalize }}</h3>
                <div class="additional-services-group">
                    <div v-for="(item2, key2) in item.group"
                         v-show="item2.isShow"
                         :key="key2"
                         class="group-item">
                        <div v-for="(item3, key3) in item2.items"
                             :key="key3"
                             class="additional-services-coontent">
                            <div class="date-info">
                                <div v-if="item3.dateItems.length === 1" class="day-info dark-small-bold-text mr-10">
                                    {{ getDateByFormat(item3.itemSelected.allData.BeginDateTime, "DD.MM.YYYY") }}
                                </div>
                                <base-select v-else
                                             :items="item3.dateItems"
                                             :cost-changed="item3.costChanged"
                                             :disabled="checkDisabled(item3)"
                                             :class="{'disabled': checkDisabled(item3)}"
                                             @change="changeAdditionalServices(key+key2, key3, 'dateItems', $event, item2)"
                                             v-model="item3.itemDateSelectedValue"/>
                            </div>
                            <div class="place-info">
                                <div v-if="item3.items.length === 1" class="dark-small-text mr-4">
                                    {{ item3.itemSelected.label }}
                                </div>
                                <base-select v-else
                                             :items="item3.items"
                                             :cost-changed="item3.costChanged"
                                             :disabled="checkDisabled(item3)"
                                             :class="{'disabled': checkDisabled(item3)}"
                                             @change="changeAdditionalServices(key+key2, key3, 'items', $event, item2)"
                                             v-model="item3.itemSelectedValue"/>
                            </div>
                            <!--                        v-if="!item3.items[0].showCheckbox"-->
                            <div class="dark-small-text align-center">
                                <div class="align-center flex-fill">
                                    <div class="popover-link mr-6"
                                         @mouseleave="hidePopover()"
                                         @mouseenter="showPopover(getQuotaText(item2), $event)">
                                        <icon :name="getQuotaName(item2, item3.itemSelected.allData.SvKey)"
                                              class="quota-icon"
                                              width="16px" height="16px" fill="var(--white-color)"/>
                                    </div>

                                    <span v-if="item2.details.length === 1" :class="['nowrap', {'mr-4': item3.itemSelected.allData.Details[0].SubCode1.Value}]">
                                        {{ item3.itemSelected.allData.Details[0].SubCode1.Value }}
                                    </span>
                                    <base-select2 v-else
                                                  :items="item2.details"
                                                  :disabled="checkDisabled(item3)"
                                                  :class="['mr-4 flex-fill', {'disabled': checkDisabled(item3)}]"
                                                  @change="changeAddintionalDetail(key+key2, $event)"
                                                  v-model="item2.selectedDetailValue"/>
                                </div>
                                <template v-if="item2.details2.length">
                                    <span v-if="item2.details2.length === 1" class="nowrap ml-4 mr-4">
                                        {{ item3.itemSelected.allData.Details[0].SubCode2.Value }}
                                    </span>
                                    <base-select2 v-else
                                                  :items="item2.details2"
                                                  :disabled="checkDisabled(item3)"
                                                  :class="['ml-4 mr-4', {'disabled': checkDisabled(item3)}]"
                                                  @change="changeAddintionalDetail2(key+key2, $event)"
                                                  v-model="item2.selectedDetailValue2"/>
                                </template>
                                <template v-if="!item3.items[0].isChecked">
                                <span v-if="item2.details2.length" class="nowrap">
                                    ({{getPlus(item2.selectedDetail2.cost) +" "+ correctPrice(item2.selectedDetail2.cost, true) +" "+ item2.details2[0].tourRate}})
                                </span>
                                    <span v-else class="nowrap">
                                    ({{getPlus(item2.selectedDetail.cost) +" "+ correctPrice(item2.selectedDetail.cost, true) +" "+ item2.details[0].tourRate}})
                                </span>
                                </template>
                            </div>
                            <!--                        v-else-->
                            <div v-if="item3.items[0].showCheckbox" class="checkbox-wrap">
                                <checkbox v-model="item3.items[0].isChecked"
                                          @change="checkedAdditionalService(item2, key3, !item3.items[0].isChecked)"
                                          :class="['nowrap', {'checked': item3.items[0].isChecked}]"
                                          :label="item3.items[0].isChecked ? localizeList.included : localizeList.notIncluded"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        name: "additional-services",
        props: {
            additionalServices: {
                type: Array,
                default: () => []
            },
            showAdditionalServicesBlock: {
                type: Boolean,
                default: true
            },
            show: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            getGroup() {
                // Делаем групировку по svKey
                let res = [];
                let svKeyWithPosition = [];
                let i = 0;

                this.additionalServices.forEach(x => {
                    const index = svKeyWithPosition.map(x2 => x2.svKey).indexOf(x.svKey);
                    if (index === -1) {
                        svKeyWithPosition.push({ svKey: x.svKey, position: i });
                        res.push({group: [x]});
                        i++
                    } else {
                        const item = svKeyWithPosition.find(x2 => x2.svKey === x.svKey);
                        const pos = item.position;

                        // Сортировка по дате, если даты равны, сохраняем порядок как был до сортировки
                        res[pos].group = [...res[pos].group, x].sort((a, b) => {
                            if (a.items[0].itemDateSelectedValue === b.items[0].itemDateSelectedValue) {
                                return 0; // Даты равны, сохраняем порядок
                            }
                            return a.items[0].itemDateSelectedValue > b.items[0].itemDateSelectedValue ? 1 : -1;
                        });
                    }
                });

                return res;
            },
        },
        methods: {
            showGroup(item) {
                return item.group.some(x => x.isShow)
            },
            getQuotaName(item, svKey) {
                const quota = item.selectedDetail.allData.QuotaStatus;
                const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);
                if (!quota || !quotaServices.includes(svKey)) {
                    return null
                }
                let res = null;
                if (quota.PlacesStatus === 2) {
                    res = "not-aviailable"
                } else if (quota.PlacesStatus === 4) {
                    res = "request"
                } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
                    res = "less"
                } else {
                    res = "aviailable"
                }
                return res
            },
            getQuotaText(item) {
                const quota = item.selectedDetail.allData.QuotaStatus;
                const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);
                if (!quota || !quotaServices.includes(2)) {
                    return null
                }

                let res = null;
                if (quota.PlacesStatus === 2) {
                    res = this.localizeList.quotaHasNoPlaces
                } else if (quota.PlacesStatus === 4) {
                    res = this.localizeList.onRequest
                } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
                    const placesLeft = quota.FreePlaces === 1 ? 'placesLeft1' : (quota.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
                    res = this.localizeList[placesLeft].replace("{}", quota.FreePlaces);
                } else {
                    res = this.localizeList.available
                }
                return res
            },
            showPopover(text, e, preType = false) {
                let rect = e.target.getBoundingClientRect();
                let res = {
                    x: rect.left + (rect.width / 2),
                    y: rect.top,
                    text: text,
                    height: rect.height,
                    preType
                };
                this.$store.dispatch('A_SHOW_POPOVER', res);

                if (preType) {
                    document.querySelector('.popover-title').style.maxWidth = 'unset'
                } else {
                    document.querySelector('.popover-title').style.maxWidth = '320px'
                }
            },
            hidePopover() {
                this.$store.dispatch('A_HIDE_POPOVER');
                document.querySelector('.popover-title').style.maxWidth = '200px'
            },
            getOrder(item) {
                return !item.IsNotCalculate || !item.IsDeleted ? 1 : 2
            },
            showBlock() {
                return this.additionalServices.some(x => x.isShow);
            },
            checkDisabled(item) {
                return item.items[0].showCheckbox && !item.items[0].isChecked
            },
            changeAdditionalServices(key, key2, prop, e, item) {
              this.$emit('changeAdditionalServices', [key, key2, prop, e, item.id])
            },
            changeAddintionalDetail(key, e) {
                this.$emit('changeAddintionalDetail', [key, e])
            },
            changeAddintionalDetail2(key, e) {
                this.$emit('changeAddintionalDetail2', [key, e, this.getGroup])
            },
            checkedAdditionalService(item, key2, value) {
                this.$emit('checkedAdditionalService', [item.id, key2, value])
            },
            blockToggle() {
                this.$emit("toggle", !this.show)
            },
            getDateByFormat(date, format) {
                return moment(date).format(format)
            },
            getPlus(numb) {
                return numb <= 0 ? "" : "+"
            },
            correctPrice(val, round = false) {
                if (round) {
                    val = Math.round(val);
                }
                const isFloat = val % 1 !== 0;
                let res = new Intl.NumberFormat().format(val);

                if (res.includes(".") || !isFloat) {
                    res = res.replace(/,/g, " ");
                } else {
                    res = res.replace(/,/g, ".");
                }
                res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
                return res
            },
        },
        filters: {
            capitalize(val) {
                return `${val[0].toUpperCase()}${val.slice(1)}`
            }
        }
    }
</script>

<style scoped>
    .block {
        background: var(--white-color);
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.11);
        border-radius: 4px;
        margin-bottom: 12px;
        transition: all .3s;
    }

    .block .block-toggle-bar {
        border-radius: 4px;
        background: var(--primary-color);
        padding: 12px 16px;
        cursor: pointer;
    }

    .block.show .block-toggle-bar {
        border-radius: 4px 4px 0 0;
    }

    .block .block-toggle-bar .block-name span {
        font-weight: bold;
        font-size: 15px;
        line-height: 18px;
        color: var(--white-color);
    }

    .block .block-toggle-bar .angle-icon {
        transform: rotate(-90deg);
        transition: all .2s;
    }

    .block.show .block-toggle-bar .angle-icon {
        transform: rotate(90deg);
        transition: all .2s;
    }

    /***ADDITIONAL SERVICES BLOCK***/
    .additional-services-info-wrap {
        display: flex;
        flex-direction: column;
    }

    .basket .additional-services-info-header {
        padding: 20px 28px 0
    }

    .basket .additional-services-info {
        padding: 16px 28px 20px;
    }

    .basket .additional-services-info .additional-services-info-headline {
        border-bottom: 2px solid #E0E0E0;
        padding: 12px 16px 12px 12px;
        background-color: var(--lighten-2-color);
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        color: #1D1D1D;
    }

    .basket .additional-services-info .additional-services-group {
        position: relative;
        background-color: var(--lighten-2-color);
        border-radius: 6px;
    }

    .basket .additional-services-info .additional-services-group .additional-services-coontent {
        display: grid;
        align-items: center;
        grid-template-columns: minmax(auto, 200px) 1fr 1fr auto;
        padding: 12px 16px 12px 12px;
        grid-gap: 10px;
    }

    .basket .additional-services-info .additional-services-group .additional-services-coontent .checkbox-wrap {
        display: flex;
        justify-content: flex-end;
    }

    .basket .additional-services-info .additional-services-group .additional-services-coontent:not(:last-child) {
        border-bottom: 1px solid #E0E0E0;
    }

    .basket .additional-services-info .additional-services-group /deep/ .additional-services-coontent .base-select .select {
        background-color: var(--white-color);
        padding-top: 8px;
        padding-bottom: 8px;
        padding-right: 26px;
    }

    .basket .additional-services-info .additional-services-group /deep/ .additional-services-coontent .disabled.base-select .select {
        background-color: #ddd;
    }

    .basket .additional-services-info .additional-services-group /deep/ .additional-services-coontent .disabled.base-select2 .select {
        background-color: #ddd;
    }

    .basket .additional-services-info /deep/ .base-select2 .select {
        white-space: nowrap;
    }

    .additional-services-info /deep/ .c-checkbox {
        justify-content: flex-end;
    }
    .additional-services-info /deep/ .c-checkbox #c-checkbox {
        color: #717171;
        grid-auto-flow: dense;
    }
    .additional-services-info /deep/ .c-checkbox #c-checkbox:before {
        grid-column-start: 2;
    }
    .additional-services-info /deep/ .c-checkbox #c-checkbox.active:after {
        left: unset;
        right: 2px;
    }
    .additional-services-info /deep/ .c-checkbox.checked #c-checkbox {
        color: var(--primary-color);
    }

</style>
